import type { TierDisplayView } from "../state/ui-types";

// export function TierDisplayNotice({ display }: { display: TierDisplayView }) {
//   const snapshot = display.status === "LAST_CONFIRMED_SNAPSHOT";
//   if (!snapshot && !display.updating) return null;
//   return <div className="tier-display-notice" role="status">
//     {display.updating ? <strong>Updating tier data…</strong> : null}
//     {snapshot ? <p>Last confirmed snapshot{display.asOfBlock === null ? "" :
//       ` · Block #${display.asOfBlock.toLocaleString("en-US")}`}. USD values use the current ETH price.</p> : null}
//     <p>Displayed tiers do not authorize minting. The backend will recheck eligibility before minting.</p>
//   </div>;
// }

// You are not allowed to edit this code, this is my intention
export function TierDisplayNotice({ display }: { display: TierDisplayView }) {
  return null
}